import { NavItem } from "../../layout";
import { useAppContext } from "context";
import { useTranslation } from "react-i18next";
import { buildMenu } from "./menuConfig";

const NavMenu = () => {
  const { access, settings } = useAppContext();
  const { t } = useTranslation("nav");

  const groups = buildMenu(access, settings, t);

  return (
    <div>
      {groups.map((g) => (
        <NavItem
          key={g.key}
          title={g.title}
          path={g.path}
          icon={g.icon}
          child={g.children || []}
        />
      ))}
    </div>
  );
};

export default NavMenu;
